<template>
  <div class="agreement-container">
    <h1>inspay APP User Privacy Agreement</h1>
    <h2>I. Introduction</h2>
    <p>
      This privacy agreement (hereinafter referred to as the “Agreement”)
      applies to all non - Mainland Chinese users of the inspay APP (hereinafter
      referred to as the “App” or “we”). This Agreement elaborates on how we
      collect, use, store, and protect your personal information to ensure the
      privacy and security during your use of the App. Please read this
      Agreement carefully before using the App. If you do not agree to any of
      the terms of this Agreement, please do not use the App.
    </p>
    <h2>II. Information Collection</h2>
    <h3>(1) Personal Information</h3>
    <p>
      When you use the App, we may collect the following types of personal
      information:
    </p>
    <ul>
      <li>
        Registration information: including your email address, password set,
        etc. for creating your account information.
      </li>
      <li>
        Identity information: In some cases, in order to comply with relevant
        laws, regulations, and financial regulatory requirements, we may need to
        collect your identity information, such as name, date of birth,
        nationality, etc. However, we will clearly inform you of the purpose and
        scope of collection.
      </li>
      <li>
        Contact information: Other contact information you provide during the
        use of the App, such as your phone number (if any), so that we can
        communicate with you when necessary.
      </li>
    </ul>
    <h3>(2) Financial Information</h3>
    <p>
      Digital currency wallet information: We will collect information related
      to your digital currency wallet, including but not limited to your USDT
      wallet address, etc., to enable the connection between digital currency
      and the services of the App, facilitating your trading operations.
    </p>
    <p>
      Credit card information: If you use the credit card opening and
      consumption functions of the App, we will collect relevant credit card
      information, such as the credit card number (only used for connection with
      payment processing institutions, and we will adopt strict encryption
      measures), expiration date, security code (only collected when necessary
      and under secure conditions, and strictly confidential), etc., to ensure
      the smooth progress of credit card transactions.
    </p>
    <h3>(3) Usage Information</h3>
    <p>
      Transaction records: We will record all your transaction information
      within the App, including digital currency recharge, exchange, VCC credit
      card opening, recharge, and consumption records. This information helps us
      provide you with accurate services, solve possible problems, and comply
      with financial regulatory requirements.
    </p>
    <p>
      Device information: To ensure transaction security and improve user
      experience, we may collect information about the device you use, such as
      device model, operating system version, unique device identifiers (such as
      IMEI, UUID, etc.), IP address, etc. This information helps us identify
      abnormal activities, prevent fraud, and optimize the performance of the
      App.
    </p>
    <p>
      Browsing and operation information: We will collect your browsing history
      and operation behavior within the App (such as buttons clicked, pages
      visited, etc.) to analyze user behavior patterns and improve our services.
    </p>
    <h2>III. Information Use</h2>
    <h3>(1) Service Provision</h3>
    <p>
      We use the collected information to implement the core functions of the
      App, including but not limited to the exchange of digital currency and
      traditional currency, and the opening and consumption services of VCC
      credit cards. For example, we use your digital currency wallet information
      and credit card information to complete recharge and consumption
      transactions.
    </p>
    <p>
      Based on your transaction records and usage habits, we provide you with
      personalized services and recommendations, such as preferential activity
      information, suggestions for more suitable payment methods, etc.
    </p>
    <h3>(2) Security and Compliance</h3>
    <p>
      To ensure the security of your account and prevent fraud, we use device
      information, transaction records, and other data for risk assessment and
      monitoring. If abnormal activities are detected, we may take corresponding
      security measures, such as requiring you to conduct additional identity
      verification.
    </p>
    <p>
      To comply with international financial regulatory requirements and
      relevant laws and regulations, we need to use some of your information for
      reporting and filing. For example, providing transaction data to relevant
      financial regulatory agencies to meet anti - money laundering (AML) and
      know - your - customer (KYC) compliance requirements.
    </p>
    <h3>(3) Service Improvement</h3>
    <p>
      Through the analysis of your usage information and feedback, we
      continuously improve the functions, user interface, and service quality of
      the App to provide a better user experience.
    </p>
    <h2>IV. Information Sharing and Disclosure</h2>
    <h3>(1) Third - Party Service Providers</h3>
    <p>
      To implement the functions of the App, we may cooperate with third - party
      service providers, such as payment processing institutions, digital
      currency trading platforms, banks, etc. These third parties may have
      access to some of your information, but only within the scope necessary to
      provide you with services, and we require them to comply with strict
      confidentiality and security regulations.
    </p>
    <p>
      For example, payment processing institutions need your credit card
      information to process transactions, and digital currency trading
      platforms may need to share wallet information with us to complete
      currency exchange operations. Before sharing information with these third
      parties, we will ensure that they have sufficient security measures to
      protect your privacy.
    </p>
    <h3>(2) Legal Requirements</h3>
    <p>
      In some cases, we may need to disclose your information according to legal
      requirements, such as receiving a court summons, an investigation request
      from a执法机构, or other legal procedures. In such cases, we will only
      disclose the necessary information and make every effort to protect your
      privacy within the scope permitted by law.
    </p>
    <p>
      If we believe that the disclosure of information is necessary to protect
      our legitimate rights and interests, prevent fraud, or other illegal
      activities, we may also disclose your information within a reasonable
      range.
    </p>
    <h2>V. Information Storage and Security</h2>
    <h3>(1) Storage Period</h3>
    <p>
      We will store your information reasonably according to business needs and
      legal requirements. Generally, as long as your account is active, we will
      keep your information continuously. After you close your account, we will
      delete or anonymize your information within a certain period in accordance
      with relevant regulations, unless otherwise required by laws and
      regulations.
    </p>
    <h3>(2) Security Measures</h3>
    <p>
      We adopt a variety of security technologies and management measures to
      protect your information, including but not limited to encryption
      technology, access control, firewalls, etc. We encrypt the storage and
      transmission of your sensitive information (such as passwords, credit
      card信息, etc.) to prevent unauthorized access and leakage.
    </p>
    <p>
      We regularly conduct security assessments and audits of our systems and
      networks to timely detect and repair possible security vulnerabilities. At
      the same time, our employees and partners must comply with strict
      confidentiality regulations to ensure the security of your information.
    </p>
    <h2>VI. User Rights</h2>
    <h3>(1) Access and Correction</h3>
    <p>
      You have the right to access and correct your personal information. You
      can request to access or modify your account information, contact
      information, etc. through the settings function within the App or by
      contacting our customer service. We will handle your request within a
      reasonable time and provide you with corresponding services under the
      premise of ensuring security.
    </p>
    <h3>(2) Deletion</h3>
    <p>
      In some cases, you have the right to request us to delete your
      information. For example, if you no longer use the App or you believe that
      we have violated this privacy agreement. We will handle your deletion
      request according to relevant laws, regulations, and business processes,
      and delete your information as soon as possible after confirmation, but
      may retain copies of some necessary information due to compliance
      requirements.
    </p>
    <h3>(3) Restriction of Processing</h3>
    <p>
      If you have objections to the way we process your information, you have
      the right to request us to restrict the treatment of your information. In
      this case, we will, under the premise of meeting legal requirements,
      decide whether to restrict the processing of your information according to
      your request and specific circumstances.
    </p>
    <h2>VII. Use by Minors</h2>
    <p>
      This App does not provide services to minors. We will not intentionally
      collect personal information of minors. If we find that minors are using
      the App, we will take appropriate measures, including deleting their
      relevant information and may restrict their use of the App.
    </p>
    <h2>VIII. Agreement Amendment</h2>
    <p>
      We may update this privacy agreement from time to time according to
      business development, changes in laws and regulations, and other factors.
      We will notify you of the changes in the content of the agreement within
      the App or through other appropriate means. After the agreement is
      changed, if you continue to use the App, it means that you accept the
      updated agreement. If you do not agree to the changed agreement, you
      should stop using the App and can request us to delete your information
      according to the provisions of the agreement.
    </p>
    <h2>IX. Contact Us</h2>
    <p>
      If you have any questions, suggestions, or complaints about this privacy
      agreement, please contact us through the following way:
      mengxiangdao123@outlook.com. We will reply to your inquiry as soon as
      possible and try our best to solve your problem.
    </p>
    <h2>X. Terms of Use for Users Aged 18 and Above</h2>
    <h3>(1) Age Confirmation</h3>
    <p>
      Before using this software and its related services, users need to confirm
      that they are 18 years old or above. If under 18 years old, please do not
      use this software, otherwise it may lead to consequences such as account
      suspension.
    </p>
    <h3>(2) Responsibility Assumption</h3>
    <p>
      Users aged 18 and above shall be solely responsible for all their
      operational behaviors within the software, including but not limited to
      fund transactions, information filling, and function usage. Any
      consequences resulting from improper user operations or violations of laws
      and regulations shall be borne by the user.
    </p>
    <h3>(3) Compliance with Laws and Regulations</h3>
    <p>
      Users need to comply with all laws and regulations in their region and the
      region where the software is operated, and shall not use the software for
      any illegal and criminal activities, such as money laundering, fraud,
      illegal fundraising, etc. If any illegal or irregular behavior of the user
      is found, this software has the right to immediately terminate the service
      and cooperate with relevant departments for investigation and handling.
    </p>
    <h3>(4) Privacy Protection and Information Security</h3>
    <p>
      This software will strictly protect the personal information security of
      users in accordance with the privacy policy. However, users should
      properly safeguard their account information, including login passwords,
      payment passwords, wallet addresses, etc., to avoid losses caused by
      information leakage. If the information leakage is due to the user's own
      reasons, this software shall not bear the corresponding responsibility.
    </p>
    <h3>(5) Service Change and Termination</h3>
    <p>
      This software has the right to change the content and rules of the
      software service or terminate part of the service according to its own
      operation situation or legal requirements. If the service change or
      termination has a significant impact on the user, this software will
      notify the user in advance. After receiving the notice, the user shall
      operate in accordance with the new regulations or requirements, otherwise
      it may affect the use of the account.
    </p>
    <h3>(6) Dispute Resolution</h3>
    <p>
      If a dispute occurs between the user and this software during the use
      process, both parties should first try to resolve it through friendly
      negotiation. If the negotiation fails, a lawsuit can be filed with the
      people's court with jurisdiction in accordance with relevant laws and
      regulations.
    </p>
    <h2>XI. SDK Information</h2>
    <h3>(1) AFNetworking</h3>
    <p>
      It is an HTTP network communication library for iOS, which provides
      lightweight network request and response handling.
    </p>
    <h3>(2) Flutter</h3>
    <p>
      It is a UI toolkit from Google, used for building cross-platform mobile
      applications and is written in the Dart language.
    </p>
    <h3>(3) Reachability</h3>
    <p>
      It is mainly used to detect the network connection status of the device.
      It can determine whether the device is connected to the network and
      through which network mode (such as Wi-Fi, mobile data, etc.) it is
      connected, facilitating the application to decide the execution of
      corresponding functions according to the network status.
    </p>
    <h3>(4) Toast</h3>
    <p>
      It is a lightweight component that briefly displays prompt messages on the
      screen. It is used to give users feedback on operation results, status and
      other simple messages. It will disappear automatically after being
      displayed for a while and will not affect the user's ongoing operation
      process.
    </p>
    <h3>(5) connectivity_plus</h3>
    <p>
      It is a Flutter plugin used to detect the network connection status of the
      device.
    </p>
    <h3>(6) device_info_plus</h3>
    <p>
      It is a Flutter plugin used to obtain device information, such as device
      name, operating system version, etc.
    </p>
    <h3>(7) package_info_plus</h3>
    <p>
      It can be used to obtain relevant package information of the application
      itself, such as application name, version number, version name and package
      name, etc., which helps the application to carry out version display,
      update check and other operations.
    </p>
    <h3>(8) share_plus</h3>
    <p>
      It is an SDK that realizes the sharing function. It enables users to share
      contents such as text, links, pictures, etc. within the application to
      other applications or platforms by calling other applications installed on
      the device to achieve the sharing purpose.
    </p>
  </div>
</template>

<style scoped>
.agreement-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px;
}

.agreement-title {
  color: #333;
  /* font-size: 32px; */
  font-weight: 600;
  text-align: center;
  margin-bottom: 40px;
  padding-bottom: 20px;
  border-bottom: 2px solid #eee;
}

/* h2 {
  color: #2c3e50;
  font-size: 24px;
  margin-top: 30px;
  margin-bottom: 20px;
} */

ol {
  padding-left: 20px;
  line-height: 1.6;
}

li {
  margin-bottom: 12px;
  color: #666;
}

p {
  color: #666;
  line-height: 1.6;
}
</style>
<script>
export default {
  name: "AccountDeletionStatement",
  created() {
    // 在组件创建时立即滚动到顶部
    window.scrollTo(0, 0);
  },
  mounted() {
    // 组件挂载后再次确保滚动到顶部
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
  },
};
</script>
